import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-item__txt" }

import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  align?: "left" | "center" | "right";
  size?: "s" | "m";
  bold?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'text-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    align: {},
    size: {},
    bold: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const componentClass = () =>
  mapModifires(
    "text-item",
    mergeModifires(
      props.modifires,
      props.align && `align-${props.align}`,
      props.size && `size-${props.size}`,
      props.bold && `weight-bold`
    )
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("p", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})